import React, { useState } from 'react';
import Slider from 'rc-slider';
import clsx from 'clsx';
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

const SettingGasFeeDropdown = ({ currentChain }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const fee = JSON.parse(localStorage.getItem(`${currentChain.blockchainName}_gasFeeMultiplier`));
  const [gasFee, setGasFee] = useState(fee || 1);
  const [customSpeed, setCustomSpeed] = useState(false);

  const modalToggle = () => {
    setOpenModal(!openModal);
  };

  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const setGasFeeHandler = () => {
    localStorage.setItem(`${currentChain.blockchainName}_gasFeeMultiplier`, JSON.stringify(gasFee));
    setOpenModal(false);
    setCustomSpeed(false);
  };

  const resetGasFeeHandler = () => {
    localStorage.removeItem(`${currentChain.blockchainName}_gasFeeMultiplier`);
    setGasFee(1);
    setOpenModal(false);
    setCustomSpeed(false);
  };

  const onCloseModal = () => {
    modalToggle();
    const fee = JSON.parse(localStorage.getItem(`${currentChain.blockchainName}_gasFeeMultiplier`));
    setGasFee(fee || 1);
    setCustomSpeed(false);
  };

  return (
    <div className="gas-fee-setting">
      <Dropdown className="email-notification" isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle className="email-notification__toggle">
          <IconSetting dropdownOpe={dropdownOpen} />
        </DropdownToggle>
        <DropdownMenu right={true}>
          <DropdownItem className="network" onClick={() => setOpenModal(true)}>
            Set Gas Fee
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Modal isOpen={openModal} toggle={modalToggle} centered size="sm" backdrop={'static'}>
        <ModalHeader className="text-capitalize action-header">
          <div className="d-flex align-items-center justify-content-between">
            <span className="text-title">Set Gas Fee</span>
            <Button
              className="m-0 p-0"
              color="link"
              onClick={onCloseModal}
              tag="a"
              style={{ fontSize: '30px' }}
            >
              &times;
            </Button>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: '16px' }}>
          {/* <div className="text-caption">
            You can set Gas Fee for all transactions on {currentChain.blockchainName} network. The
            higher Gas Fee, the more chance for your transaction to be confirmed. For more about Gas
            Fee, please click
            <a
              className="ml-1"
              href="https://metamask.zendesk.com/hc/en-us/articles/4404600179227-User-Guide-Gas"
              target="_blank"
              rel="noreferrer"
            >
              here
            </a>
            .
          </div> */}
          <div>
            {customSpeed ? (
              <>
                <div className="d-flex justify-content-between mb-2">
                  <div
                    className="d-flex align-items-center cursor-pointer text-body-2"
                    onClick={() => setCustomSpeed(false)}
                  >
                    <img
                      src="/images/icons/back.png"
                      alt="ic-back"
                      height={12}
                      style={{ marginBottom: '3px' }}
                    />
                    <div className="ml-1">Custom Speed</div>
                  </div>
                  <span className="text-body-1">{gasFee}x</span>
                </div>
                <div className="px-1">
                  <Slider
                    min={1}
                    max={50}
                    value={gasFee}
                    onChange={(e) => setGasFee(e)}
                    onAfterChange={(e) => console.log(e)}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="text-body-2">Speed</div>
                <div className="d-flex gas-fee-options mt-2">
                  <span className={clsx({ active: gasFee === 1 })} onClick={() => setGasFee(1)}>
                    Standard
                  </span>
                  <span className={clsx({ active: gasFee === 2 })} onClick={() => setGasFee(2)}>
                    Fast
                  </span>
                  <span className={clsx({ active: gasFee === 5 })} onClick={() => setGasFee(5)}>
                    Very Fast
                  </span>
                  <span
                    className={clsx({ active: ![1, 2, 5].includes(gasFee) })}
                    onClick={() => setCustomSpeed(true)}
                  >
                    Custom
                  </span>
                </div>
              </>
            )}

            <hr />
            <div className="d-flex justify-content-between align-items-center">
              <div className="text-body-2">Gas Fee</div>
              <div className="text-body-1">{gasFee} GWEI</div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="mb-2">
          <hr />
          <div className="d-flex w-100 mx-2">
            <Button
              type="button"
              size="sm"
              color="default"
              outline
              className="w-100 mx-2"
              disabled={!fee}
              onClick={resetGasFeeHandler}
            >
              Reset
            </Button>
            <Button
              type="button"
              size="sm"
              color="primary"
              className="w-100 mx-2"
              onClick={setGasFeeHandler}
            >
              Set Gas Fee
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SettingGasFeeDropdown;

function IconSetting(props) {
  const emailFill = props.dropdownOpen ? '#28AFEC' : '#576E86';

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 0H2C0.89543 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.89543 23.1046 0 22 0Z"
        fill="white"
      />
      <path
        d="M12.0008 8.80078C11.3679 8.80078 10.7492 8.98846 10.223 9.34008C9.69672 9.6917 9.28657 10.1915 9.04437 10.7762C8.80217 11.3609 8.7388 12.0043 8.86227 12.6251C8.98574 13.2458 9.29051 13.816 9.73804 14.2635C10.1856 14.7111 10.7558 15.0158 11.3765 15.1393C11.9972 15.2628 12.6406 15.1994 13.2254 14.9572C13.8101 14.715 14.3099 14.3048 14.6615 13.7786C15.0131 13.2524 15.2008 12.6337 15.2008 12.0008C15.2008 11.1521 14.8636 10.3382 14.2635 9.73804C13.6634 9.13792 12.8495 8.80078 12.0008 8.80078V8.80078ZM12.0008 13.6008C11.6843 13.6008 11.375 13.5069 11.1119 13.3311C10.8488 13.1553 10.6437 12.9054 10.5226 12.6131C10.4015 12.3207 10.3698 11.999 10.4315 11.6886C10.4933 11.3783 10.6456 11.0932 10.8694 10.8694C11.0932 10.6456 11.3783 10.4933 11.6886 10.4315C11.999 10.3698 12.3207 10.4015 12.6131 10.5226C12.9054 10.6437 13.1553 10.8488 13.3311 11.1119C13.5069 11.375 13.6008 11.6843 13.6008 12.0008C13.6008 12.4251 13.4322 12.8321 13.1322 13.1322C12.8321 13.4322 12.4251 13.6008 12.0008 13.6008Z"
        fill={emailFill}
      />
      <path
        d="M19.4358 13.5204L19.0806 13.3156C19.2405 12.4455 19.2405 11.5536 19.0806 10.6836L19.4358 10.4788C19.709 10.3212 19.9484 10.1114 20.1405 9.86124C20.3325 9.61112 20.4734 9.32562 20.5551 9.02105C20.6368 8.71647 20.6578 8.39878 20.6167 8.08612C20.5756 7.77345 20.4734 7.47194 20.3158 7.19879C20.1582 6.92564 19.9484 6.68621 19.6983 6.49415C19.4481 6.3021 19.1627 6.1612 18.8581 6.07948C18.5535 5.99776 18.2358 5.97684 17.9231 6.0179C17.6105 6.05896 17.309 6.1612 17.0358 6.31879L16.6798 6.52439C16.0074 5.94993 15.2348 5.50459 14.4006 5.21079V4.80039C14.4006 4.16387 14.1478 3.55342 13.6977 3.10333C13.2476 2.65325 12.6371 2.40039 12.0006 2.40039C11.3641 2.40039 10.7537 2.65325 10.3036 3.10333C9.85348 3.55342 9.60062 4.16387 9.60062 4.80039V5.21079C8.76653 5.50564 7.9941 5.95207 7.32222 6.52759L6.96462 6.32039C6.41297 6.00213 5.75749 5.91605 5.14237 6.08108C4.52725 6.24611 4.00288 6.64874 3.68462 7.20039C3.36636 7.75204 3.28028 8.40753 3.44531 9.02264C3.61034 9.63776 4.01297 10.1621 4.56462 10.4804L4.91982 10.6852C4.75991 11.5552 4.75991 12.4471 4.91982 13.3172L4.56462 13.522C4.01297 13.8403 3.61034 14.3646 3.44531 14.9797C3.28028 15.5949 3.36636 16.2503 3.68462 16.802C4.00288 17.3536 4.52725 17.7563 5.14237 17.9213C5.75749 18.0863 6.41297 18.0003 6.96462 17.682L7.32062 17.4764C7.99323 18.0509 8.7662 18.4963 9.60062 18.79V19.2004C9.60062 19.8369 9.85348 20.4474 10.3036 20.8974C10.7537 21.3475 11.3641 21.6004 12.0006 21.6004C12.6371 21.6004 13.2476 21.3475 13.6977 20.8974C14.1478 20.4474 14.4006 19.8369 14.4006 19.2004V18.79C15.2347 18.4951 16.0071 18.0487 16.679 17.4732L17.0366 17.6796C17.5883 17.9979 18.2438 18.0839 18.8589 17.9189C19.474 17.7539 19.9984 17.3512 20.3166 16.7996C20.6349 16.2479 20.721 15.5925 20.5559 14.9773C20.3909 14.3622 19.9883 13.8379 19.4366 13.5196L19.4358 13.5204ZM17.3974 10.4996C17.6683 11.4812 17.6683 12.5179 17.3974 13.4996C17.3501 13.6704 17.3609 13.8522 17.4281 14.0162C17.4953 14.1803 17.6151 14.3174 17.7686 14.406L18.6358 14.9068C18.8197 15.0129 18.9538 15.1877 19.0088 15.3927C19.0638 15.5977 19.0351 15.8161 18.929 16C18.8229 16.1838 18.6482 16.318 18.4431 16.373C18.2381 16.428 18.0197 16.3993 17.8358 16.2932L16.967 15.7908C16.8133 15.7018 16.6344 15.6664 16.4584 15.6903C16.2824 15.7142 16.1194 15.796 15.995 15.9228C15.283 16.6497 14.3859 17.1684 13.4006 17.4228C13.2286 17.467 13.0763 17.5672 12.9675 17.7075C12.8587 17.8479 12.7997 18.0204 12.7998 18.198V19.2004C12.7998 19.4126 12.7155 19.616 12.5655 19.7661C12.4155 19.9161 12.212 20.0004 11.9998 20.0004C11.7876 20.0004 11.5842 19.9161 11.4341 19.7661C11.2841 19.616 11.1998 19.4126 11.1998 19.2004V18.1988C11.1999 18.0212 11.1409 17.8487 11.0321 17.7083C10.9234 17.568 10.771 17.4678 10.599 17.4236C9.6137 17.1681 8.71688 16.6484 8.00542 15.9204C7.88104 15.7936 7.71801 15.7118 7.54202 15.6879C7.36604 15.664 7.1871 15.6994 7.03342 15.7884L6.16622 16.29C6.0752 16.3433 5.97453 16.3782 5.87 16.3925C5.76547 16.4068 5.65914 16.4002 5.55714 16.3733C5.45514 16.3463 5.35949 16.2994 5.27568 16.2353C5.19187 16.1713 5.12156 16.0912 5.06881 15.9999C5.01606 15.9085 4.9819 15.8076 4.9683 15.703C4.9547 15.5983 4.96193 15.4921 4.98957 15.3902C5.01722 15.2884 5.06473 15.1931 5.12937 15.1097C5.19401 15.0263 5.2745 14.9565 5.36622 14.9044L6.23342 14.4036C6.38698 14.315 6.50676 14.1779 6.57395 14.0138C6.64114 13.8498 6.65192 13.668 6.60462 13.4972C6.33371 12.5155 6.33371 11.4788 6.60462 10.4972C6.65107 10.3267 6.63977 10.1456 6.57247 9.98222C6.50517 9.81883 6.38567 9.68232 6.23262 9.59399L5.36542 9.09319C5.18157 8.9871 5.0474 8.81233 4.99241 8.60731C4.93743 8.4023 4.96613 8.18384 5.07222 7.99999C5.17831 7.81614 5.35308 7.68197 5.5581 7.62698C5.76311 7.572 5.98157 7.6007 6.16542 7.70679L7.03422 8.20919C7.18748 8.2984 7.36604 8.33416 7.54184 8.31085C7.71764 8.28753 7.88071 8.20647 8.00542 8.08039C8.71749 7.35347 9.61456 6.83481 10.5998 6.58039C10.7723 6.53604 10.9251 6.43539 11.0339 6.29439C11.1428 6.15339 11.2014 5.9801 11.2006 5.80199V4.80039C11.2006 4.58822 11.2849 4.38473 11.4349 4.23471C11.585 4.08468 11.7884 4.00039 12.0006 4.00039C12.2128 4.00039 12.4163 4.08468 12.5663 4.23471C12.7163 4.38473 12.8006 4.58822 12.8006 4.80039V5.80199C12.8005 5.97956 12.8595 6.15211 12.9683 6.29246C13.0771 6.4328 13.2294 6.53298 13.4014 6.57719C14.387 6.83251 15.2841 7.3523 15.9958 8.08039C16.1202 8.20716 16.2832 8.28894 16.4592 8.31284C16.6352 8.33674 16.8141 8.3014 16.9678 8.21239L17.835 7.71079C17.926 7.65743 18.0267 7.6226 18.1312 7.60831C18.2358 7.59402 18.3421 7.60054 18.4441 7.62751C18.5461 7.65448 18.6418 7.70135 18.7256 7.76544C18.8094 7.82953 18.8797 7.90956 18.9324 8.00093C18.9852 8.0923 19.0193 8.1932 19.0329 8.29782C19.0465 8.40245 19.0393 8.50873 19.0117 8.61054C18.984 8.71236 18.9365 8.80771 18.8719 8.89109C18.8072 8.97447 18.7267 9.04424 18.635 9.09639L17.7678 9.59719C17.6151 9.68576 17.4959 9.82237 17.4289 9.98575C17.3619 10.1491 17.3508 10.3301 17.3974 10.5004V10.4996Z"
        fill={emailFill}
      />
    </svg>
  );
}
